export const UNSAVED_PROFILE_ID = "unsaved";
export const DUMMY_PROFILE_NAME = "Persona";
export const DROPDOWN_BUTTON_TEXT_LENGTH_LIMIT = 40;
